export enum EGameName {
  JACKPOT_SLOTS = 'jackpot-slots',
  BIG_FISH_CASINO = 'big-fish-casino',
}

export enum EGradientDirection {
  TopToBottom = 'to bottom',
  BottomToTop = 'to top',
  LeftToRight = 'to right',
  RightToLeft = 'to left',
  TopLeftToBottomRight = 'to bottom right',
  BottomRightToTopLeft = 'to top left',
  TopRightToBottomLeft = 'to bottom left',
  BottomLeftToTopRight = 'to top right',
}

export enum EFontWeights {
  Normal = 'normal',
  Bold = 'bold',
  Bolder = 'bolder',
}

export enum EBundlesInternalViewModel {
  AK = 'ak',
  MATCH = 'match',
  CANDIVORE = 'candivore',
  COMMUNIX = 'communix',
  COMMUNIX2 = 'communix2',
  MAIN_SUB = 'mainSub',
  BAGELCODE = 'bagelcode',
  BAGELCODE2 = 'bagelcode2',
  LOCO_BINGO = 'locobingo',
  JACKPOT_SLOTS = 'jackpot-slots',
  BIG_FISH_CASINO = 'big-fish-casino',
  CASHMAN_CASINO = 'cashman-casino',
  EVERGREEN_DYNAMIC = 'evergreen-dynamic',
  LIGHTNING_LINK_CASINO = 'lightning-link-casino',
  HEART_OF_VEGAS = 'heart-of-vegas',
  ME2ON = 'me2on',
  PLAY_SIMPLE = 'play-simple',
  PIPA = 'pipa',
  WHISPERS = 'whispers',
  BABA = 'baba',
  MIGHTY_FU_CASINO = 'mighty-fu-casino',
  GHOST = 'ghost',
  BINGO_POP = 'bingo-pop',
  LIGHTNING_LINK_CASINO2 = 'lightning-link-casino2',
}

export enum ESpecialOfferInternalViewModel {
  HUGE = 'hug',
  MATCH_MASTERS = 'match-masters',
  POKER_FACE = 'pokerFace',
  BAGELCODE = 'bagelcode',
  LOCO_BINGO = 'locobingo',
  ME2ON = 'me2on',
  PIPA = 'pipa',
  JACKPOT_SLOTS = 'jackpot-slots',
  BIG_FISH_CASINO = 'big-fish-casino',
  PLAY_SIMPLE = 'play-simple',
  BABA = 'baba',
  GHOST = 'ghost',
  BINGO_POP = 'bingo-pop',
}

export enum ERollingOffersInternalViewModel {
  HUGE = 'huge',
}

export enum ESubRollingOfferCollectMode {
  COLLECTED = 'collected',
  AVAILABLE = 'available',
  LOCKED = 'locked',
}

export enum ESubRollingOfferCollectBehavior {
  DISAPPEAR = 'disappear',
  STAY = 'stay',
}

export enum EArrowDirection {
  RIGHT = 'right',
  LEFT = 'left',
  DOWN = 'down',
}

export enum EProductType {
  TIME = 'Time',
  QUANTITY = 'Quantity',
}

export enum EProductPriority {
  MAIN = 'Main',
  SUB = 'Sub',
}

export enum EBadgePosition {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
  CENTER = 'center',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  TOP_CENTER = 'top-center',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_CENTER = 'bottom-center',
  CENTER_CENTER = 'center-center',
}

export enum EBadgeType {
  EMBLEM = 'emblem',
  RIBBON = 'ribbon',
  SALE = 'sale',
}

export enum EPlatformType {
  IOS = 'ios',
  ANDROID = 'android',
  WEB = 'web',
}

export enum EAppleResponseType {
  CODE = 'code',
  ID_TOKEN = 'code id_token',
}

export enum EOTPModel {
  STATIC = 'static',
  DYNAMIC_LINK = 'dynamicLink',
}

export enum EOTPTextModel {
  SIX_DIGITS = 'sixDigits',
  FOUR_DIGITS = 'fourDigits',
  MOBILE_ONLY = 'mobileOnly',
}

export enum ELoginEvents {
  LOGIN_CANCELED = 'LOGIN_CANCELED',
  LOGIN_SCREEN_PRESENTED = 'LOGIN_SCREEN_PRESENTED',
  LOGIN_APPROVAL = 'LOGIN_APPROVAL',
  LOGIN_BUTTON_CLICKED = 'LOGIN_BUTTON_CLICKED',
  LOGIN_OTP_IOS_BUTTON = 'LOGIN_OTP_IOS_BUTTON',
  LOGIN_OTP_ANDROID_BUTTON = 'LOGIN_OTP_ANDROID_BUTTON',
  OTP_BUTTON_CLICKED = 'OTP_BUTTON_CLICKED',
  OTP_CODE_ENTERED = 'OTP_CODE_ENTERED',
  PLAYER_ID_BUTTON_CLICKED = 'PLAYER_ID_BUTTON_CLICKED',
  PLAYER_PASSWORD_BUTTON_CLICKED = 'PLAYER_PASSWORD_BUTTON_CLICKED',
}

export enum ESessionStorageKeys {
  REDIRECT_STATE = 'redirectState',
}

export enum ESaleDiscountDisplayType {
  PERCENTAGE = 'percentage',
  MULTIPLIER = 'multiplier',
  FIXED_AMOUNT = 'fixed_amount',
}

export enum EBundlesViewModel {
  LINEAR = 'linear',
  TWO_IN_ONE = 'twoInOne',
  THREE_IN_ONE = 'threeInOne',
  SIX_IN_ONE = 'sixInOne',
  TWO_IN_ONE_DYNAMIC = 'twoInOneDynamic',
}

export enum EBalancesTheme {
  DEFAULT = 'default',
  BAGELCODE = 'bagelcode',
  SPACEGO = 'spacego',
  PRODUCT_MADNESS = 'product-madness',
  ME2ON = 'me2on',
  PLAY_SIMPLE = 'play-simple',
  PIPA = 'pipa',
  WHISPERS = 'whispers',
  GHOST = 'ghost',
  BINGO_POP = 'bingo-pop',
}

export enum StoreBodyBlock {
  dailyBonus = 'dailyBonus',
  playerLevel = 'playerLevel',
  banners = 'banners',
  specialOffers = 'specialOffers',
  rollingOffers = 'rollingOffers',
  bundles = 'bundles',
}

export enum EOfferType {
  BUNDLE = 'Bundle',
  ROLLING_OFFER = 'RollingOffer',
  SPECIAL_OFFER = 'SpecialOffer',
  POP_UP = 'PopUp',
}

export enum EPopupSubType {
  DAILY_BONUS = 'DailyBonus',
  POST_PURCHASE = 'PostPurchase',
}

export enum EQueryParams {
  MESSAGE = 'msg',
  ORDER_ID = 'order_id',
  ERROR = 'error',
  LOCAL_ADDRESS = 'local_address',
  LOGIN_REDIRECT = 'login_redirect',
  IS_IFRAME = 'is_iframe',
  CURRENCY_CODE = 'currencyCode',
  FROM = 'from',
  TOKEN = 'token',
  OFFER_ID = 'offerId',
  DYNAMO_LINK_ID = 'd10x_link_id',
  DYNAMO_ORG = 'd10x_org',
}

export enum ESectionsViewModel {
  DEFAULT = 'default',
  BAGEL_CODE = 'bagelcode',
  PIPA = 'pipa',
  Whispers = 'whispers',
  LLC = 'llc',
  MIGHTY_FU_CASINO = 'mighty-fu-casino',
  GHOST = 'ghost',
}

export enum EConfigs {
  desktopMaxWidth = 'desktopMaxWidth',
  rollingOfferMaxWidth = 'rollingOfferMaxWidth',
  maxWidthOverride = 'maxWidthOverride',
  gapX = 'gapX',
  gapY = 'gapY',
  marginTop = 'marginTop',
  bannerMaxWidth = 'bannerMaxWidth',
  bannerMinWidth = 'bannerMinWidth',
  bannerMX = 'bannerMarginX',
}

export enum ECheckoutPageEvent {
  BACK_TO_STORE = 'backToStore',
  BACK_TO_GAME = 'backToGame',
  SUPPORT = 'support',
  ORDER_CREATED = 'appcharge_order_created',
  PAYMENT_INTENT_SUCCESS = 'appcharge_payment_intent_success',
  PAYMENT_INTENT_FAILED = 'appcharge_payment_intent_failed',
  ORDER_COMPLETED_SUCCESS = 'appcharge_order_completed_success',
  ORDER_COMPLETED_FAILED = 'appcharge_order_completed_failed',
  CLOSE_CHECKOUT = 'appcharge_close_checkout',
  CHECKOUT_OPENED = 'appcharge_checkout_opened',
}

export interface CheckoutEventParams {
  supportUrl: string;
  returnToGameLinkAddress: string;
  isOrderSucceed: boolean;
}

export enum ELogoSize {
  SMALL = 'small',
  LARGE = 'big',
}

export enum OfferClassName {
  BUNDLE = 'bundle',
  ROLLING_OFFER = 'sub-offer',
  SPECIAL_OFFER = 'carousel-item',
}
